import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class ContractorsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.contractors).get(options);
  }

  post(item) {
    return this.$resource(apis.contractors).save(item);
  }

  search(query = "", params) {
    return this.$resource(apis.contractors + "autocomplete").get(
      assign(params, { query })
    );
  }
}

export default ContractorsResource;



// WEBPACK FOOTER //
// ./src/resources/contractors/contractors.resource.js